<template>
  <div>
    <Head title="Sales Returns Receipts" />
    <h1 class="mb-8 text-3xl font-bold">Sales Returns Receipts</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-date-range v-model="search.search" class="mr-0 w-full max-w-md mr-3" @reset="resetSearch" />
      <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset" />
    </div>
    <div class="flex items-center justify-between mb-6">
      <a
        v-if="(orders.data.length > 0 && url())"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/packed-orders/download${url()}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Order Number</th>
          <th class="pb-3 pt-3 px-3">Customer</th> 
          <th class="pb-3 pt-3 px-3">Region</th>
          <th class="pb-3 pt-3 px-3">City</th>
          <th class="pb-3 pt-3 px-3">Total CBM</th>
          <th class="pb-3 pt-3 px-3">Waybill Number</th>
          <th class="pb-3 pt-3 px-3 text-end" />
        </tr>
        <tr v-for="list in orders.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/picked-return-orders/${list.id}`" title="">
              {{ list.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/picked-return-orders/${list.id}`" title="">
              {{ list.order_no }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/picked-return-orders/${list.id}`" title="">
              {{ list.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/picked-return-orders/${list.id}`" title="">
              {{ list.region }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/picked-return-orders/${list.id}`" title="">
              {{ list.city }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/picked-return-orders/${list.id}`" title="">
              {{ list.total_cbm }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/picked-return-orders/${list.id}`" title="">
              {{ list.waybill_no }}
            </Link>
          </td>
          <td class="w-px border-t">
            <a :href="`/picked-return-orders/${list.id}`" class="flex items-center justify-end pr-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="10">No data found</td>
        </tr>
      </table>
    </div>
    <br>
    <pagination class="mt-6" :links="orders.links" />
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'
      
export default {
  components: {
    Head,
    Link,
    SearchWithDateRange,
    Pagination,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
  },
  data() {
    return {
      search: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/picked-return-orders', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    url() {
      let query = '';
      if (this.search.search) {
        if (query) {
          query += '&';
        }
        query += `search=${this.search.search}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>
      